import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={101}
    height={props.width? `calc( ${props.width}/ 101 * 101 )`: 101}
    viewBox="0 0 101 101"
    fill="none"
    {...props}
  >
    <path
      fill="url(#acb)"
      stroke="#0AC5A3"
      d="M74.745 7.266 99.471 50.5 74.745 93.734H25.301L.577 50.5 25.302 7.266h49.443Z"
    />
    <path
      fill="#25FFD8"
      fillOpacity={0.2}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M77.67 67.25v-31.5L50.336 20 23 35.75v31.5L50.335 83l27.336-15.75Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M50.335 39.277V20M23 67.06l14.392-8.373M77.67 67.25l-16.053-9.387"
    />
    <defs>
      <radialGradient
        id="acb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-50.0236 0 0 -50.5 50.023 50.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0AC5A3" stopOpacity={0.5} />
        <stop offset={1} stopColor="#0AC5A3" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)
export default SvgComponent
